import { useEffect, useState } from "react";

const links = [
  { href: "#channel", label: "栏目" },
  { href: "#rank", label: "热议榜" },
  { href: "#archive", label: "起底档案" },
  { href: "#feature", label: "深扒长文" },
  { href: "#timeline", label: "内幕线" },
  { href: "#topic", label: "话题墙" },
  { href: "#collection", label: "档案馆" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={
        "sticky top-0 z-50 transition-all duration-300 " +
        (scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-foreground-950/8 shadow-[0_1px_0_0_rgba(0,0,0,0.02)]"
          : "bg-transparent border-b border-transparent")
      }
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-3 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
            <i className="ri-focus-3-line text-lg" />
          </span>
          <span className="flex items-baseline gap-2">
            <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">网黑料</span>
            <span className="hidden text-xs tracking-[0.3em] text-foreground-500 lg:inline">PERSON · ARCHIVE</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#search"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/10 bg-background-50 px-3 py-2 text-sm text-foreground-600 transition-colors hover:border-foreground-950/25 hover:text-foreground-950 sm:flex"
          >
            <i className="ri-search-line text-sm" />
            <span>检索人物 / 事件</span>
          </a>
          <a
            href="#archive"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
          >
            <span>进入档案库</span>
            <i className="ri-arrow-right-line text-sm" />
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-foreground-950/10 md:hidden"
          >
            <i className="ri-menu-line text-lg text-foreground-950" />
          </button>
        </div>
      </div>
    </header>
  );
}